import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    location: "bottom",
    start: "",
    "min-width": "175",
    "max-width": "280",
    "nudge-bottom": "4"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _createTextVNode("mdi-apps")
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        density: "compact",
        class: "pa-0 mt-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_subheader, null, {
            default: _withCtx(() => [
              _createTextVNode("SYSDYNE CLOUD")
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_list_item, {
            href: _ctx.products.cloudbatch.url,
            target: "_blank"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "ms-4" }, {
                default: _withCtx(() => [
                  _createTextVNode(" mdi-open-in-new ")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.products.cloudbatch.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["href"]),
          _createVNode(_component_v_list_item, {
            href: _ctx.products.concretego.url,
            target: "_blank"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "ms-4" }, {
                default: _withCtx(() => [
                  _createTextVNode(" mdi-open-in-new ")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.products.concretego.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["href"]),
          _createVNode(_component_v_list_item, {
            target: "_blank",
            href: _ctx.products.istrada.url
          }, {
            append: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "ms-4" }, {
                default: _withCtx(() => [
                  _createTextVNode(" mdi-open-in-new ")
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.products.istrada.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["href"]),
          (_ctx.features.menuProductsBI)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                target: "_blank",
                href: _ctx.products.bi.url
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { class: "ms-4" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" mdi-open-in-new ")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.products.bi.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"]))
            : _createCommentVNode("", true),
          (_ctx.features.menuProductsTTEditor)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 1,
                target: "_blank",
                href: _ctx.products.tteditor.url
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.products.tteditor.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" mdi-open-in-new ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["href"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}